module.exports = __webpack_public_path__ + "static/media/printing-services-img11.aa038aac.jpg";